<template>
  <!-- NAV ON PHOTO TODO: FIX ALIGNMENT -->
  <div class="container-fluid">
    <div class="button-areas">
      <div class="row border-bottom pt-2 pb-2">
        <div class="col-2 col-lg-3 col-md-2 pl-1 pr-0">

          <button v-if="!is_filter_active" type="button" @click="openNav" :class="{active : is_filter_active, filtersactive: $store.state.photo.filtersactive}" class="btn btn-light filter-btn filter-icon-sidebar ml-1">
            <img class="plus-img"  src="@/assets/images/img-icons/filter2_black.svg" alt="img" >
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
            <span class="icons-text-top-bar"> Filter</span>
          </button>
          <button v-else type="button" @click="openNav" :class="{active : is_filter_active, filtersactive: $store.state.photo.filtersactive}" class="btn btn-light filter-btn ml-1">
            <img class="plus-img white" src="@/assets/images/img-icons/filter2_white.svg" alt="image">
            <span class="icons-text-top-bar"> Filter</span>
          </button>

          <button type="button" class="btn btn-light btn-modal ml-1 import-btn" data-toggle="modal" data-target=".uploadModal" :disabled="!usercan('editor')">
            <i class="fa-solid fa-arrow-up-from-bracket pr-1" title="Fotos importieren"></i>
            <span class="icons-text-top-bar"> Fotos importieren </span>
          </button>
          <button type="button" class="btn btn-light ml-1 simple-photo-check" @click="openBottomNav" :disabled="isEdit"   v-bind:class="{active : isBottomNav}">
            <i class="fa-regular fa-clone pr-1 font13" title="Fotos auswählen" ></i>
            <span class="icons-text-top-bar-lg"> Fotos auswählen </span>
          </button>
        </div>
        <!-- DateRangeSlider START -->
<!--        <div class="col-xl-6 col-lg-5 col-md-3 photo-top-midle">-->
        <div class="col photo-top-midle px-1">
          <div id="datepicker_f" class="d-flex input-group this-calender input-group-sm date mr-2 ml-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
            <input id="datepicker_from"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   v-model="dateRangeFrom"
                   readonly="">
          </div>


<!--          <div id="datepicker" class="d-flex date date-pick datepicker mr-2 ml-auto" data-date-format="dd.mm.yyyy">-->
<!--            <span class="input-group-addon this-calender">-->
<!--              <i class="fa-regular fa-calendar-minus"></i>-->
<!--            </span>-->
<!--            <input id="datepicker_from"-->
<!--                data-date-format="dd.mm.yyyy"-->
<!--                class="form-control date-input ml-1"-->
<!--                 v-model="dateRangeFrom" type="text" readonly="">-->
<!--&lt;!&ndash;            $store.state.photo.endDate&ndash;&gt;-->
<!--          </div>-->


<!--           With number fields-->
<!--          <div class="filter level-filter level-req">-->
<!--              <VueSimpleRangeSlider  activeBarColor="#ffff"-->
<!--                                     :min="1"-->
<!--                                     :max="240"-->
<!--                                     :logarithmic="false"-->
<!--                                     v-model="range"-->
<!--                                     name="fotoDateRangeSlider"-->
<!--              />-->
<!--          </div>-->


          <div class="filter level-filter level-req">
            <input type="text" class="photos-js-range-slider js-range-slider" id="ionRangeSlider" name="my_range" value="" />
          </div>




          <div id="datepicker_t" class="d-flex input-group this-calender input-group-sm date ml-2 mr-auto datepicker_small_input" data-date-format="dd.mm.yyyy">
            <input id="datepicker_to"
                   type="text"
                   class="form-control date-input"
                   data-date-format="dd.mm.yyyy"
                   v-model="dateRangeTo"
                   readonly="" style="margin-top: 0">
            <div class="input-group-append">
              <span class="input-group-text" ><i class="fa-regular fa-calendar-minus"></i></span>
            </div>
          </div>

<!--          <div class="d-flex date date-pick ml-2 datepicker mr-auto" data-date-format="dd.mm.yyyy">-->
<!--            <input-->
<!--                id="datepicker_to"-->
<!--                data-date-format="dd.mm.yyyy"-->
<!--                class="form-control date-input ml-1"-->
<!--                v-model="dateRangeTo"  -->
<!--                type="text" readonly="">-->
<!--&lt;!&ndash;            $store.state.photo.startDate&ndash;&gt;-->
<!--            <span class="input-group-addon this-calender"><i class="fa-regular fa-calendar-minus"></i></span>-->
<!--          </div>-->



        </div>
        <!-- DateRangeSlider END -->
        <div class="right-btn action-btns col-xl-3 col-lg-4 col-md-4  text-right d-none  d-sm-block p-0">
          <button type="button" :class="{active : isOverView, 'btn btn-light':true}" @click="overview" :disabled="$store.state.photo.dirty"> {{$t('overview')}} </button>
          <button type="button" :class="{ active : isDetailView}" @click="toggleDetails" class="btn btn-light ml-1" :disabled="$store.state.photo.dirty">Details</button>
          <button type="button" :class="{ active : isMapView}" @click="toggleMap"  class="btn btn-light ml-1" :disabled="$store.state.photo.dirty"> {{$t("plan_view")}} </button>
          <button type="button" :class="{ active : isEdit}" @click="toggleEditMode()" id="edit-sidebtn" class="btn btn-light ml-2 mr-1" :disabled="!usercan('editor') || $store.state.photo.dirty">
            <i class="fa-regular fa-pen-to-square font14" :title="$t('edit')"></i> <span class="icons-text-top-bar"> {{$t("edit")}} </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueSimpleRangeSlider from 'vue-simple-range-slider'
import '../../../assets/css/slider.css'
import moment from 'moment'
import {mapState} from 'vuex'
export default {
  name: 'photo-nav',
  //  props: ["fromDate","toDate"],
  data () {
    return {
      is_filter_active: false,
      is_plain_active: false,
      isSelecteAble: false,
      // range: [0, 360],
      typingTimer:'',
      sliderInit: false,


      dateRangeFrom: moment(new Date()).add(-3, 'year').format('DD.MM.YYYY'),
      dateRangeTo: moment(new Date()).format('DD.MM.YYYY'),
    }
  },
  components: {
    VueSimpleRangeSlider
  },
  computed: {
    ...mapState({
      isBottomNav: state => state.photo.isBottomNav,
      isDetailView: state => state.photo.isDetailView,
      isOverView: state => state.photo.isMainView,
      isMapView: state => state.photo.isMapView,
      editPhoto: state => state.photo.editPhoto,
      currentproject: state => state.current.project,
      filtersActive: state => state.filtersactive
    }),

    isEdit: {
      get () {

        return this.$store.state.photo.isEdit
      },
      set (val) {
        this.$store.commit('toggleEdit', val)
      }
    },

    dateTo: {
      get () {
        return this.$store.state.photo.dateRangeTo
      },
      set (val) {
        this.$store.state.photo.dateRangeTo = val
        // this.$store.commit('setDateRangeTo', val)
      }
    },
    range: {
      get () {
        return this.$store.state.photo.range
      },
      set (val) {
        this.$store.state.photo.range = val
        // this.$store.commit('setDateRangeTo', val)
      }
    },

    dateFrom: {
      get () {
        return this.$store.state.photo.dateRangeFrom
      },
      set (val) {
        this.$store.state.photo.dateRangeFrom = val
        // this.$store.commit('setDateRangeFrom', val)
      }
    },

    dateMin: {
      get () {
        // console.log('Get dateMin', this.$store.state.photo.meta.minimumdate)

        if(this.$store.state.photo.meta.minimumdate == undefined || this.$store.state.photo.meta.minimumdate == '') {
          return undefined
        }

        return moment(this.$store.state.photo.meta.minimumdate).format('YYYY-MM-DD')
        return this.$store.state.meta.minimumDate
      },
      set (val) {
        // this.$store.commit('setDateRangeFrom', val)
      }
    },
    dateMax: {
      get () {
        // console.log('Get dateMax', this.$store.state.photo.meta.maximumdate)

        if(this.$store.state.photo.meta.maximumdate == undefined || this.$store.state.photo.meta.maximumdate == '') {
          return undefined
        }

        return moment(this.$store.state.photo.meta.maximumdate).format('YYYY-MM-DD')
        return this.$store.state.meta.maximumDate
      },
      set (val) {
        // this.$store.commit('setDateRangeFrom', val)
      }
    },

  },

  mounted () {
    // $('#datepicker').datepicker({
    //   autoclose: true,
    //   todayHighlight: true
    // })
    // $('#datepicker1').datepicker({
    //   autoclose: true,
    //   todayHighlight: true
    // })

    // $('#datepicker,#datepicker1').change(function () {
    //   $(this)[0].dispatchEvent(new Event('input'))
    // })

    $('.uploadModal').on('hide.bs.modal', function () {
      $('.btn-modal').removeClass('active')
    })

    $('.uploadModal').on('show.bs.modal', function () {
      $('.btn-modal').addClass('active')
    })


    console.log('DR - Min Max', this.dateMin, this.dateMax, this.range)

    if(this.dateMin != undefined && this.dateMax != undefined) {

      console.log('DR - RUN setDatePicker')

      this.setDatePickers();
    }

  },

  methods: {


    toggleEditMode(btnEdit = false) {
      //
      if(this.isMapView == 0) {
        if(!this.isDetailView) {
          this.toggleDetails()
        }
      }

      console.log('Toggle Edit', this.$store.state.photo.activefilters.plansKeys)

      if(this.isMapView) {

        if(!this.isEdit && this.$store.state.photo.activefilters.plansKeys) {
          this.$store.state.photo.removePlanFilter = true
        }

        if(this.isEdit && this.$store.state.photo.canvasplan) {
          // alert('Restore A')
          // console.log('PhotoStore A', this.$store.state.photo)
          this.$store.state.photo.restorePlanFilter = true
        }

      }



      if(this.isEdit == false) {
        this.$store.state.photo.isBottomNav = false
      }
      this.isEdit = btnEdit || !this.isEdit
    },

    setDateRangeSlider(){
      let _this = this
      $(".photos-js-range-slider").ionRangeSlider({
        type: "double",
        min: _this.range[0],
        max: _this.range[1],
        drag_interval: true,
        hide_min_max: true,
        hide_from_to: true,
        onFinish: function (val){
          _this.onSliderChange(val);

          $('#datepicker_from').datepicker("setDate", $('#datepicker_from').val())
          $('#datepicker_to').datepicker("setDate", $('#datepicker_to').val())

        },
        onChange: function (val){
          _this.onSliderChangeStep(val);
        }
      });
    },


    async setDatePickers () {
      // Define Base Values!
      let mindate = this.dateMin
      let maxdate = this.dateMax
      //
      this.dateRangeFrom = moment(mindate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this.dateRangeTo = moment(maxdate, 'YYYY-MM-DD').format('DD.MM.YYYY')

      // console.log('DR - SetDatePickers', {
      //   'MinDate': mindate,
      //   'MaxDate': maxdate,
      //   'This.DateFrom': this.dateFrom,
      //   'This.DateTo': this.dateTo
      // })
      await this.setDateRangeSlider();
      let my_range = $("#ionRangeSlider").data("ionRangeSlider");
      let _this = this
      // $('.datepicker').datepicker({
      $('#datepicker_to, #datepicker_from').datepicker({
        autoclose: true,
        todayHighlight: true
      }).change(function (event){


        let value = event.target.value;
        let from =  mindate;
        if (event.target.getAttribute('id') === 'datepicker_from'){
          let dif_from = moment(value , 'DD.MM.YYYY');
          let dif = moment.duration(dif_from.diff(from)).asDays();
          console.log('Dif From', dif, dif_from, from)
          my_range.update({
            from: Math.floor(dif),
          });
        } else {
          let to =  maxdate;
          let dif_to = moment(value , 'DD.MM.YYYY');
          let difToDate = moment.duration(dif_to.diff(to)).asDays();
          my_range.update({
            to: Math.ceil(_this.range[1] + difToDate),
            // to: Math.floor(_this.range[1] + difToDate),
          });
        }

        let d_from = $('#datepicker_from').val();
        let d_to = $('#datepicker_to').val();
        _this.dateFrom = d_from;
        _this.dateTo  = d_to;
        _this.dateRangeFrom = d_from;
        _this.dateRangeTo  = d_to;

        _this.$store.state.photo.endDate = _this.dateRangeFrom
        _this.$store.state.photo.startDate = _this.dateRangeTo
      });
    },

    onSliderChange(val){
      this.setDateRanges([val.from , val.to]);
    },

    onSliderChangeStep(val){
      let from = val.from;
      let to = val.to;

      console.log('DR - CHANGE ', val)

      let from_to_dates = this.calcDate([val.from, val.to])

      this.dateRangeFrom = from_to_dates[0]
      this.dateRangeTo = from_to_dates[1]


      // this.dateRangeFrom = moment(this.dateMin).add(from * 3, 'days').format('DD.MM.YYYY');
      // this.dateRangeTo = moment(this.dateMax).add((to * 3) - 1075, 'days').format('DD.MM.YYYY')

      console.log('DR - onSliderChangeStep', this.dateRangeFrom, this.dateRangeTo)

    },

    async dateChanged () {
      await this.$root.$emit('afterDateChange')
    },

    setDateRanges (range) {
      let _this = this
      let from = range[0];
      let to = range[1];

      let from_to_dates = this.calcDate(range)

      _this.$store.state.photo.RangeFrom = from_to_dates[0]
      _this.$store.state.photo.RangeTo = from_to_dates[1]

      _this.$store.state.photo.endDate = _this.$store.state.photo.RangeFrom
      _this.$store.state.photo.startDate = _this.$store.state.photo.RangeTo

      console.log('DR - setDateRanges', range, {
        'From': _this.$store.state.photo.RangeFrom,
        'To' :_this.$store.state.photo.RangeTo
      })

    },

    calcDate (range) {
      let _this = this
      let from = range[0] // Slider Left Point
      let to = range[1] // Slider Right Point

      let mindate = this.dateMin
      let maxdate = this.dateMax
      let oneday = 24 * 60 * 60 * 1000
      let firstDate = new Date(mindate)
      let secondDate = new Date(maxdate)
      let diffdays = Math.round(Math.abs((firstDate - secondDate) / oneday))

      let diffcounter = ''
      if(diffdays <= _this.range[1]) {
        //diffcounter = _this.range[1]
        diffcounter = diffdays / _this.range[1]
      } else {
        diffcounter = Math.round(diffdays / _this.range[1])
      }

      // console.log('caldDate', {
      //   'from': from,
      //   'to': to,
      //   'mindate': mindate,
      //   'maxdate': maxdate,
      //   'diffdays': diffdays,
      //   'diffcounter': diffcounter
      // })


      let from_date = moment(new Date(mindate)).add((from - 1) * diffcounter, 'days').format('DD.MM.YYYY')
      let to_date = moment(new Date(maxdate)).add( (to-_this.range[1]) * diffcounter, 'days').format('DD.MM.YYYY')

      // console.log('From_Date - To_Date', from_date, to_date)


      return [from_date, to_date]
    },



    openNav () {
      this.is_filter_active = this.is_filter_active === false
      this.$store.commit('setNav', this.is_filter_active)
    },
    openBottomNav () {
      let _this = this
      if(_this.$store.state.photo.isBottomNav) {
        _this.$store.state.photo.selectedPhotos = []
      } else {
        // _this.$store.state.photo.slider_active_image = 0
        let cuimg = _this.$store.state.photo.photos[0]
        let payload_a = { id: _this.$route.params.id, img_id: cuimg.pdphotoid }
        _this.$store.dispatch('getImageDetails', payload_a)
        let payload_b = {id: cuimg.pdphotoid, src: cuimg.path, projectid: cuimg.projectid}
        _this.$store.state.photo.slider_active_image = payload_b
      }

      this.$store.commit('imageSelectableToggle')

      // this.state.photo.selectedPhotos
    },
    toggleDetails () {

      this.$store.state.photo.dirty = false
      if (this.isDetailView) {
        this.is_plain_active = false
        this.$store.commit('setDetailsView')
      } else {
        this.$store.commit('setDetailsView')
      }
    },

    overview () {
      this.isOverview = true
      this.isEdit = false
      if (this.isOverview) {
        this.is_plain_active = false
        this.$store.commit('setOverView')
      } else {
        this.$store.commit('setOverView')
      }
    },

    toggleMap () {
      this.$store.commit('setMapView')
    },

  },
  watch: {
    'editPhoto': function (val){
      console.log('isEdit - nav.vue editPhoto', this.isEdit, this.$store.state.photo.isEditPhoto)
      if (!this.isEdit){
        if(this.$store.state.photo.isEditPhoto) {
          this.toggleEditMode(true);
        }
      }
      if(!this.$store.state.photo.isEditPhoto) {
        this.isEdit = false;
      }
    },
    'range': async function () {
      // console.log('CallDateRanges')
      // await this.setDateRanges()
    },

    '$store.state.photo.meta.minimumdate': function(v) {

      // console.log('this.$store.state.photo.meta.minimumdate Changed', this.$store.state.photo.meta.minimumdate)

      if(this.$store.state.photo.meta.minimumdate !== '') {


        let dif_from = moment(this.$store.state.photo.meta.minimumdate);
        let dif_to = moment(this.$store.state.photo.meta.maximumdate);
        let dif = moment.duration(dif_to.diff(dif_from)).asDays();
        this.range = [0, dif];

        // console.log('Start setDatePickers', this.$store.state.photo.meta.minimumdate, this.$store.state.photo.meta.maximumdate, 0, dif)

        this.setDatePickers()
        this.sliderInit = true
      }


    },

    // '$store.state.photo.RangeFrom': function (v) {
    '$store.state.photo.endDate': function (v) {
      this.$store.state.photo.endDate = this.$store.state.photo.endDate
      this.$store.state.photo.RangeFrom = this.$store.state.photo.endDate
      this.dateChanged()
    },
    // '$store.state.photo.RangeTo': function (v) {
    '$store.state.photo.startDate': function (v) {
      this.$store.state.photo.startDate = this.$store.state.photo.startDate
      this.$store.state.photo.RangeTo = this.$store.state.photo.startDate
      this.dateChanged()
    }
  }
}
</script>
<style scoped>
  .active{
    background-color: #39F !important;
    color: #ffffff !important;
  }
  /*.btn-light {*/
  /*  line-height: 18px !important;*/
  /*  background: white !important;*/
  /*  font-size: 0.75rem !important;*/
  /*  font-weight: 400;*/
  /*  color: #333 !important;*/
  /*  padding: .2rem .8rem .2rem .8em !important;*/
  /*  border: 1px solid lightgrey !important;*/
  /*  border-radius: 8px;*/
  /*}*/
  .right-btn.action-btns button{
    font-size: 0.7rem !important;
  }
  .btn-light:hover{
    color: white !important;
    background: dodgerblue !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/photo/components/nav.vue